module.exports = __webpack_public_path__ + "static/media/f-phone.f1d2cd07.svg";